import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'use-intl';

import { SignupContent } from '@/screens/signup/SignupContent';
import { htmlConfig } from '@/lib/html-config';

export const Route = createFileRoute('/_app/signup/')({
  component: SignupRoute,
});

function LoadingSpinner() {
  const t = useTranslations('signup.form');
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{t('loading')}</p>
      </div>
    </div>
  );
}

function SignupRoute() {
  // Public Turnstile site key, baked into index.html at build time.
  const turnstileSitekey = htmlConfig('turnstile-sitekey') ?? '';
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <SignupContent turnstileSitekey={turnstileSitekey} />
    </Suspense>
  );
}
